import React, {FC, ReactNode} from "react"
import styled from "styled-components"

import IconText from "../IconText"
import {IconTypes} from "../Icon"

export interface ErrorTextProps {
  icon?: IconTypes
  small?: boolean
  children: ReactNode
}

const Icon: FC<ErrorTextProps> = ({children, icon, ...rest}) => (
  <IconText icon={icon || IconTypes.circleAlertFill} {...rest}>
    *{children}
  </IconText>
)

export default styled(Icon)`
  color: ${({theme}) => theme.colors.tertiary.r_400};
`
